
import React from 'react';
import { MdHome, MdAccountCircle, MdDirectionsCar, MdAttachMoney, MdDescription, MdStar, MdSettings, MdHelp, MdWarning, MdEdit } from 'react-icons/md';
import { FaCar, FaUser, FaPhone, FaEnvelope, FaLock, FaCalendar, FaMapMarkerAlt, FaIdCard, FaCarSide, FaShieldAlt, FaPassport, FaSync, FaBars, FaArrowLeft, FaTimes, FaEdit, FaTrash, FaCheckCircle, FaComment, FaPaperPlane, FaSignOutAlt, FaCalendarDay, FaCalendarWeek, FaCalendarAlt, FaChevronRight, FaUpload, FaExclamationCircle, FaClock, FaRoute, FaMapMarkedAlt, FaClock as FaClockTime, FaUserCircle, FaCar as FaCarIcon, FaCheck, FaTimesCircle } from 'react-icons/fa';


export const iconMap: Record<string, any> = {

  'home': MdHome,
  'account': MdAccountCircle,
  'menu': FaBars,
  'arrow-left': FaArrowLeft,
  'arrow-back': FaArrowLeft,
  'chevron-right': FaChevronRight,
  'close': FaTimes,


  'car': FaCarIcon,
  'directions-car': MdDirectionsCar,
  'car-outline': FaCarSide,
  'car-sports': FaCar,
  'car-multiple': MdDirectionsCar,


  'file-document': MdDescription,
  'file-document-outline': MdDescription,
  'file-edit-outline': MdEdit,
  'upload': FaUpload,
  'card-account-details': FaIdCard,
  'card-account-details-outline': FaIdCard,
  'passport': FaPassport,


  'check-circle': FaCheckCircle,
  'check': FaCheck,
  'cancel': FaTimesCircle,
  'edit': FaEdit,
  'delete': FaTrash,
  'refresh': FaSync,


  'message-text-outline': FaComment,
  'send': FaPaperPlane,
  'phone': FaPhone,
  'phone-outline': FaPhone,
  'email': FaEnvelope,
  'email-outline': FaEnvelope,


  'lock-outline': FaLock,
  'lock': FaLock,
  'lock-check-outline': FaLock,
  'shield-check': FaShieldAlt,


  'map-marker': FaMapMarkerAlt,
  'map-marker-outline': FaMapMarkerAlt,
  'map-marker-path': FaRoute,
  'map-marker-distance': FaMapMarkedAlt,
  'navigation-variant': FaRoute,
  'navigation': FaRoute,


  'calendar-outline': FaCalendar,
  'calendar-today': FaCalendarDay,
  'calendar-clock-outline': FaClock,
  'clock-time-four-outline': FaClockTime,
  'clock-outline': FaClock,
  'today': FaCalendarDay,
  'date-range': FaCalendarWeek,
  'calendar-month': FaCalendarAlt,
  'calendar-clock': FaClock,


  'account-outline': FaUser,
  'account-circle': FaUserCircle,
  'account-alert-outline': FaUserCircle,
  'person': FaUser,


  'cash': MdAttachMoney,
  'currency-usd': MdAttachMoney,
  'wallet': MdAttachMoney,


  'star': MdStar,


  'alert': FaExclamationCircle,
  'alert-circle': FaExclamationCircle,
  'identifier': FaIdCard,


  'color-lens': FaCar,
  'event-seat': FaCar,
  'logout': FaSignOutAlt,
  'help': MdHelp,
  'settings': MdSettings,
  'warning': MdWarning,
  'folder': MdDescription,
};


export const MaterialCommunityIcons: React.FC<{
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}> = ({ name, size = 24, color = '#000', style }) => {
  const IconComponent = iconMap[name] || MdHelp;
  return React.createElement(IconComponent, { size, color, style });
};

export default MaterialCommunityIcons;

